module.exports = __webpack_public_path__ + "img/collection-weddingRingsSignature@2x.6b85c78.webp";